
import React from 'react'
import DepartmentListTable from './components/DepartmentListTable'
import AddItemBtn from 'Common/Custom/AddItemBtn';
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const DepartmentList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Department List</HeadingOne>
                    <AddItemBtn url="department-add" title="Add Department" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <DepartmentListTable />
            </div>
        </PageBody>
    );
};

export default DepartmentList;
